<template>
	<!-- <input type="text" v-model="search" /> -->
	<div id="map"></div>
</template>

<script setup>
	import { ref, onMounted, onUnmounted } from 'vue';
	import { DateTime } from 'luxon';
	import axios from 'axios';

	const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || import.meta.env.GOOGLE_MAPS_API_KEY || '';
	const search = ref('');
	const structureContacts = ref({});

	const lastReleventLogDate = (contact) => {
		for (let index = 0; index < contact.logs.length; index++) {
			if (
				contact.logs[index].status.slug === 'created' ||
				contact.logs[index].status.slug === 'visit' ||
				contact.logs[index].status.slug === 'call'
			) {
				return contact.logs[index].date_at;
			}
		}
		return contact.created_at;
	};

	const buildContent = (parameters) => {
		const glyph = document.createElement('div');
		glyph.innerHTML = '<i class="fa-solid fa-' + (parameters.structure ? 'hospital' : 'user') + '"></i>';
		let classArray = [];
		if (parameters.skills) {
			classArray = parameters.skills.map((skill) => skill.slug);
		}
		classArray.push(parameters.structure ? 'structure' : 'user', parameters.color);
		const content = document.createElement('div');
		content.classList.add(...classArray);
		content.innerHTML = `
    <div class="IPAZAH-content-container HJDHPx-interactive" style="pointer-events: none;">
      <div class="GMAMP-maps-pin-view" style="display: grid; grid-template-columns: auto; grid-template-rows: 5.5px auto; gap: 0px; justify-items: center; pointer-events: none; user-select: none; width: 26px; height: 38px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="26px" height="38px" viewBox="0 0 26 37" style="display: block; overflow: visible; grid-area: 1;">
          <g fill="none" fill-rule="evenodd" style="pointer-events: auto;">
            <path class="RIFJN-maps-pin-view-border" d="M13 0C5.8175 0 0 5.77328 0 12.9181C0 20.5733 5.59 23.444 9.55499 30.0784C12.09 34.3207 11.3425 37 13 37C14.7225 37 13.975 34.2569 16.445 30.1422C20.085 23.8586 26 20.6052 26 12.9181C26 5.77328 20.1825 0 13 0Z" fill="${parameters.border}"></path>
            <path class="RIFvHW-maps-pin-view-background" fill="${parameters.color}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"></path>
            <path class="KWCFZI-maps-pin-view-default-glyph" d="M13 18C15.7614 18 18 15.7614 18 13C18 10.2386 15.7614 8 13 8C10.2386 8 8 10.2386 8 13C8 15.7614 10.2386 18 13 18Z" fill="white" style="display: none;"></path>
          </g>
        </svg>
        <div style="grid-area: 2; display: flex; align-items: center; justify-content: center; color: white; width: 15px; height: 15px;">
          <div>${glyph.innerHTML}</div>
        </div>
      </div>
    </div>
  `;
		return content;
	};

	const initMap = async () => {
		const { Map, InfoWindow } = await google.maps.importLibrary('maps');
		const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

		const map = new Map(document.getElementById('map'), {
			zoom: 10,
			center: { lat: 48.5833, lng: 7.75 },
			mapId: 'pospectMap',
		});

		const infoWindow = new InfoWindow();

		try {
			const response = await axios.post(route('contacts.map'));
			const curDate = DateTime.now();

			response.data.forEach((contact) => {
				const positionObj = new google.maps.LatLng(contact.coordinates[0], contact.coordinates[1]);
				const name = contact.first_name ? contact.first_name + ' ' + contact.last_name : contact.name;
				const date = DateTime.fromISO(lastReleventLogDate(contact));

				let parameters = {
					color: '#DDDDDD',
					border: '#AAAAAA',
					structure: contact.name ? true : false,
					skills: contact.skills,
				};

				if (curDate.minus({ days: 7 }).startOf('day') > date.startOf('day')) {
					parameters.color = '#00DD00';
					parameters.border = '#00AA00';
				}
				if (curDate.minus({ days: 14 }).startOf('day') > date.startOf('day')) {
					parameters.color = '#DDDD00';
					parameters.border = '#AAAA00';
				}
				if (curDate.minus({ month: 1 }).startOf('day') > date.startOf('day')) {
					parameters.color = '#DD0000';
					parameters.border = '#AA0000';
				}

				const marker = new google.maps.marker.AdvancedMarkerElement({
					position: positionObj,
					map: map,
					content: buildContent(parameters),
					title: name,
					gmpClickable: true,
				});

				let headerContent = '';
				let popupContent = '';
				if (contact.first_name) {
					headerContent = contact.first_name + ' ' + contact.last_name;
				} else {
					headerContent = contact.name;
				}

				popupContent += '<p class="date mt-1">Mis à jour : ' + date.toRelativeCalendar() + '</p>';
				if (contact.skills) {
					popupContent += '<div class="flex gap-1 mt-1">';
					contact.skills.forEach((skill) => {
						popupContent += '<span class="speciality">' + skill.name + '</span>';
					});
					popupContent += '</div>';
				}
				if (contact.status) {
					popupContent += '<p class="border-b b-2 mt-1"> Status : ' + contact.target.name + '</p>';
				}
				if (contact.phone) {
					popupContent += '<p class="phone mt-1">Téléphone : ' + contact.phone + '</p>';
				}
				if (contact.schedule) {
					popupContent += '<div class="mt-1"><p> Horaire : </p>';
					popupContent += '<p class="schedule">' + contact.schedule + '</p></div>';
				}

				if (contact.first_name) {
					popupContent +=
						'<div class="flex flex-row gap-2 justify-between mt-2"><a href="' +
						route('contacts.get', contact.id) +
						'" class="button">Detail</a>';
				} else {
					popupContent +=
						'<div class="flex flex-row gap-2 justify-between mt-2"><a href="' +
						route('structures.get', contact.id) +
						'" class="button">Detail</a>';
				}

				popupContent +=
					'<a href="https://www.google.fr/maps/search/' +
					contact.address +
					(contact.city ? contact.city : '') +
					'" class="button"> Google maps </a> </div>';

				marker.addListener('click', ({ domEvent, latLng }) => {
					const { target } = domEvent;
					infoWindow.close();
					infoWindow.setContent(popupContent);
					infoWindow.setHeaderContent(headerContent);
					infoWindow.open(marker.map, marker);
				});
			});

			structureContacts.value = response.data;
		} catch (error) {
			console.error(error);
		}
	};

	onMounted(() => {
		const script = document.createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly&libraries=maps,marker&callback=initMap`;
		script.async = true;
		script.defer = true;
		document.head.appendChild(script);

		window.initMap = initMap;
	});
</script>

<style>
	#map {
		height: 80vh;
		width: 100%;
	}
	.gm-style-iw-d div h1 {
		font-size: 24px;
	}
	.gm-style-iw-d div .date {
		font-size: 12px;
		color: #aaaaaa;
	}
	.gm-style-iw-d div .button {
		background-color: #4477ff;
		color: #eee;
		padding: 4px;
		border-radius: 3px;
	}
	.gm-style-iw-d div .button:hover {
		background-color: #6699ff;
	}
	.gm-style-iw-d div .speciality {
		border: solid #6699ff 2px;
		border-radius: 4px;
		padding: 3px;
		margin-right: 5px;
	}
</style>
